<template>

    <div>

        <div class="d-flex  flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">

            <h1 class="h2">
                Monitoring
            </h1>

            <div
                v-if="data !== null"
                class="d-flex flex-column ml-2"
            >
                <small>

                    <span>
                        Mis à jour le : <strong>{{ last_call.format('DD/MM/YYYY - HH:mm:ss') }}</strong>
                    </span>

                    <button
                        v-if="auto_refresh === false"
                        class="btn btn-custom btn-sm"
                        @click="getReport"
                    >
                        <i class="fas fa-sync"/>
                    </button>

                    <button
                        class="btn btn-sm"
                        :class="{'btn-custom': auto_refresh === false, 'btn-success' : auto_refresh === true}"
                        @click="auto_refresh = !auto_refresh"
                    >
                        maj auto : {{ auto_refresh === true ? 'Actif' : 'Inactif' }}
                    </button>

                </small>

                <small>
                    <span>En service depuis : <strong>{{ data.server.uptime }}</strong></span>
                </small>

            </div>

        </div>

        <div v-if="data !== null">

            <div class="row my-4">

                <div class="col-12 ">
                    <h3 class="h3">Ressources</h3>
                </div>

                <div class="col-12">

                    <div class="row">

                        <div class="col-3">
                            <div class="d-flex flex-column service">
                                <span class="service-name">RAM</span>
                                <span>Utilisé : {{ data.server.ram.used }}</span>
                                <span>Total : {{ data.server.ram.total }}</span>
                            </div>
                        </div>

                        <div
                            v-for="(item,name) in data.server.disks"
                            class="col-3"
                        >
                            <div class="d-flex flex-column  service">
                                <span class="service-name">{{ name }}</span>
                                <span>Utilisé : {{ item.used }}</span>
                                <span>Total : {{ item.total }}</span>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <hr>

            <div class="row my-4">

                <div class="col-12">
                    <h3 class="h3">Services</h3>
                </div>

                <div class="col-12">

                    <div class="row">

                        <div
                            v-for="(status, name) in data.server.services"
                            class="col-3"
                        >
                            <div class="d-flex flex-column service">
                                <span class="service-name">{{ name }}</span>
                                <span class="service-status">Statut :
                                    <span :class="{ 'active-status' : status === 'active', 'inactive-status': status !== 'active' }">
                                        {{ status }}
                                    </span>
                                </span>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <hr>

            <div class="row my-4">

                <div class="col-12 mb-1">
                    <h3 class="h3">Jobs</h3>
                </div>

                <div class="col-12">

                    <div class="row mb-3">

                        <div class="col-2">
                            <span v-if="!!data.server.monitored_jobs.global.waiting_job_quantity">
                                Total jobs en attente : {{ data.server.monitored_jobs.global.waiting_job_quantity }}
                            </span>
                            <span v-else>
                                Total jobs en attente : -
                            </span>
                        </div>

                        <div class="col-2">
                            <span v-if="!!data.server.monitored_jobs.global.failed_job_quantity">
                                Total jobs en erreur : {{ data.server.monitored_jobs.global.failed_job_quantity }}
                            </span>
                            <span v-else>
                                Total jobs en erreur : -
                            </span>
                        </div>

                    </div>

                    <div class="row">

                        <div
                            v-for="(jobInfos) in data.server.monitored_jobs.details"
                            class="col-6 mb-2"
                        >
                            <div class="d-flex flex-column service">
                                <span class="long-service-name">{{ jobInfos.report_field_label }}</span>
                                <span>Jobs en attente : {{ jobInfos.waiting_job_quantity }}</span>
                                <span>Temps d'attente du job le plus ancien :
                                    <span
                                        v-if="!!jobInfos.waiting_time_of_the_oldest_job"
                                        :class="{ 'active-status' : jobInfos.max_waiting_time_in_minutes_before_warning >= jobInfos.waiting_time_of_the_oldest_job, 'inactive-status': jobInfos.max_waiting_time_in_minutes_before_warning < jobInfos.waiting_time_of_the_oldest_job }"
                                    >
                                        {{ jobInfos.waiting_time_of_the_oldest_job }} {{ jobInfos.unit_of_waiting_time_of_the_oldest_job }}
                                    </span>
                                    <span v-else>-</span>
                                </span>
                                <span>Jobs en erreur :
                                    <span :class="{ 'active-status' : jobInfos.failed_job_quantity <= 0, 'inactive-status': jobInfos.failed_job_quantity > 0 }">
                                        {{ jobInfos.failed_job_quantity }}
                                    </span>
                                </span>
                            </div>
                        </div>

                    </div>

                    <div class="row mt-3">

                        <div class="col-12 mb-2">
                            <span class="long-service-name">
                                Statuts des workers
                            </span>
                        </div>

                        <div
                            v-for="(workerStatus, workerName) in data.server.monitored_jobs.global.workers"
                            class="col-12"
                        >
                            <div class="d-flex flex-column service">
                                <span>{{ workerName }} :
                                    <span :class="{ 'active-status' : workerStatus === 'RUNNING', 'inactive-status': workerStatus !== 'RUNNING' }">
                                        {{ workerStatus }}
                                    </span>
                                </span>
                            </div>
                        </div>

                        <div
                            v-if="data.server.monitored_jobs.global.workers.length === 0"
                            class="col-12"
                        >
                            <span class="inactive-status">
                                Le service supervisor n'est pas actif : aucun statut de worker
                            </span>
                        </div>

                    </div>

                </div>

            </div>

            <hr>

            <div class="row my-4">

                <div class="col-12">
                    <h3 class="h3">Crons</h3>
                </div>

                <div class="col-12">

                    <div class="row">

                        <div
                            v-for="(status, name) in data.server.crons"
                            class="col-6"
                        >
                            <div class="d-flex flex-column service">
                                <span class="service-name">{{ name }}</span>
                                <span>Dernier appel : {{ parseDate(status.last_execution) }}</span>
                                <span>Dernier resultat :
                                    <span :class="{ 'active-status' : status.last_result === 'OK', 'inactive-status': status.last_result !== 'OK' }">
                                        {{ status.last_result }}
                                    </span>
                                </span>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <hr>

            <div class="row my-4">

                <div class="col-3">

                    <h3 class="h3">
                        Trash
                    </h3>

                    <div class="row">

                        <div class="col-12 d-flex flex-column">
                            <span>Quantité : {{ data.server.first_and_last_entry.trash.quantity }}</span>
                            <span>Date premier : {{ dateOfFirstTrashEntry }}</span>
                            <span>Date dernier: {{ dateOfLastTrashEntry }}</span>
                        </div>

                    </div>

                </div>

                <div class="col-3">

                    <h3 class="h3">
                        Exports PV
                    </h3>

                    <div class="row">

                        <div class="col-12 d-flex flex-column">
                            <span>Quantité en erreur : {{ data.server.first_and_last_entry.fine.quantity }}</span>
                            <span>
                                Date premier : {{ getFormattedDateContent(data.server.first_and_last_entry.fine.first) }}
                            </span>
                            <span>
                                Date dernier: {{ getFormattedDateContent(data.server.first_and_last_entry.fine.last) }}
                            </span>
                        </div>

                    </div>

                </div>

                <div class="col-3">

                    <h3 class="h3">
                        Exports Quittances
                    </h3>

                    <div class="row">

                        <div class="col-12 d-flex flex-column">
                            <span>Quantité en erreur : {{ data.server.first_and_last_entry.if.quantity }}</span>
                            <span>
                                Date premier : {{ getFormattedDateContent(data.server.first_and_last_entry.if.first) }}
                            </span>
                            <span>
                                Date dernier: {{ getFormattedDateContent(data.server.first_and_last_entry.if.last) }}
                            </span>
                        </div>

                    </div>

                </div>

                <div class="col-3">
                    <h3>Appareils : {{ data.server.count.number_devices }}</h3>
                </div>

            </div>

        </div>

        <infringement-search-result-modal/>

    </div>

</template>

<script>

import moment from "moment";
import Swal from "sweetalert2";
import Vuetable from "vuetable-2";
import InfringementSearchResultModal from "./layout/InfringementSearchResultModal";

export default {
    name: "Monitoring",
    components: {InfringementSearchResultModal},
    data() {
        return {
            loading: false,
            data: null,
            last_call: null,
            auto_refresh: false
        }
    },
    computed: {
        dateOfFirstTrashEntry() {
            if (!! this.data.server.first_and_last_entry.trash.first) {
                return this.parseDate(this.data.server.first_and_last_entry.trash.first.created_at);
            } else {
                return "-";
            }
        },
        dateOfLastTrashEntry() {
            if (!! this.data.server.first_and_last_entry.trash.last) {
                return this.parseDate(this.data.server.first_and_last_entry.trash.last.created_at);
            } else {
                return "-";
            }
        },
    },
    mounted() {
        this.getReport()
        this.autoRefresh()
    },
    methods: {
        getReport() {
            this.loading = true
            setTimeout(() => {
                axios.get('/api/monitoring/report')
                    .then(res => {
                        this.data = res.data
                        this.last_call = moment()
                        this.loading = false
                    })
                    .catch(err => {
                        Swal(
                            'Echec du chargement !',
                            'impossible de récupérer la donnée depuis le serveur.',
                            'error'
                        );
                        this.loading = false
                    })
            }, 1000)
        },
        getFormattedDateContent(model) {
            if (!! model) {
                return this.parseDate(model.created_at);
            } else {
                return "-";
            }
        },
        parseDate(date) {
            return moment(date).format('DD/MM/YYYY - HH:mm:ss')
        },
        autoRefresh() {
            setInterval(() => {
                if (this.auto_refresh) {
                    this.getReport()
                }
            }, 2000)
        }
    }
}
</script>

<style scoped>
.full-width {
    width: 100%;
}

.service-name {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 1.1rem;
}

.long-service-name {
    font-weight: bold;
    font-size: 1.1rem;
}

.long-service-name:first-letter {
    text-transform: uppercase !important;
}

.active-status {
    font-weight: bold;
    color: green;
}

.inactive-status {
    font-weight: bold;
    color: red;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Monitoring.vue